import React from "react";
import "./OurFastCasinoGameDevelopmentServicesStyle.scss";
import { ourFastCasinoGameDevelopmentServicesTextContent } from "./constant/index";
import SectionHeading from "../Common_UI_Kit/SectionHeading";
import CustomButton from "../Common_UI_Kit/CustomButton";
import { useNavigate } from "react-router-dom";

const OurFastCasinoGameDevelopmentServicesSection = () => {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate(`/contact-us`);
  };

  return (
    <section className="our-fast-casino-game-development-services-section">
      <div className="our-fast-casino-game-development-services-wrap">
        <SectionHeading>{ourFastCasinoGameDevelopmentServicesTextContent.headingText}</SectionHeading>

        <div className="our-fast-casino-game-development-services-box">
          <div className="our-fast-casino-game-development-services-container">
            <div className="img-box">
              <img src={ourFastCasinoGameDevelopmentServicesTextContent.imageSrc} alt="Images" />
            </div>

            <div className="text-box">
              {ourFastCasinoGameDevelopmentServicesTextContent.content.map((section, index) =>
                section.listContent_1 && section.listContent_1.length > 0 ? (
                  <ul className="list-text-box" key={index}>
                    {section.listContent_1.map((item, itemIndex) => (
                      <li className="list-text" key={itemIndex}>
                        {item.listText}
                      </li>
                    ))}
                  </ul>
                ) : null
              )}
              
              {ourFastCasinoGameDevelopmentServicesTextContent.content.map((section, index) =>
                section.listContent_2 && section.listContent_2.length > 0 ? (
                  <ul className="list-text-box" key={index}>
                    {section.listContent_2.map((item, itemIndex) => (
                      <li className="list-text" key={itemIndex}>
                        {item.listText}
                      </li>
                    ))}
                  </ul>
                ) : null
              )}
            </div>
          </div>

          <div className="btn-box">
            <CustomButton
              buttonType="secondary"
              label={ourFastCasinoGameDevelopmentServicesTextContent.btnText}
              onClick={handleButtonClick}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurFastCasinoGameDevelopmentServicesSection;
